// Renders `text` with any occurrences of `query` (case-insensitive) underlined
// in the SCS terracotta accent — for fast eye-scanning in search results.
import React from "react";

function escapeRegExp(s) {
    return String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

/**
 * <Highlight text="Weekly office deep clean" query="office" />
 *   → "Weekly [office] deep clean" with "office" underlined.
 * Safe on strings, empty query, missing text.
 */
export function Highlight({ text, query }) {
    if (text === null || text === undefined) return null;
    const str = String(text);
    const q = (query || "").trim();
    if (!q) return str;

    const parts = str.split(new RegExp(`(${escapeRegExp(q)})`, "ig"));
    return parts.map((part, i) =>
        part.toLowerCase() === q.toLowerCase() ? (
            <mark
                key={i}
                className="bg-transparent underline decoration-2 underline-offset-2 decoration-[var(--terracotta)] text-inherit font-semibold"
            >
                {part}
            </mark>
        ) : (
            <React.Fragment key={i}>{part}</React.Fragment>
        )
    );
}
